module.exports = __webpack_public_path__ + "img/csharp.cbdc26f9.png";